export default "__VITE_ASSET__oWTba$kq__"